<script>
import HsSectionCard from "@/base/hs-tableview/hs-section/hs-section-card.vue";
import HsFormCell from "@/base/hs-tableview/hs-section/hs-form-cell.vue";
import HsCellSmallTitle from "@/base/hs-tableview/hs-cell-small-title/hs-cell-small-title.vue";
import HsTag from "@/base/hs-tag/hs-tag.vue";
import HsTeleport from "@/base/hs-teleport/hs-teleport.vue";
import CConvertPinyin from "@/pages/personal/passengers/passenger-details/c-convert-pinyin.vue";
import HsFormCellDes from "@/base/hs-tableview/hs-section/hs-form-cell-des.vue";
import state from "@/store/state";
import CPicker1 from "@/components/c-picker/c-picker-1.vue";
import mixinDes from "@/common/mixin/passenger/mixin-des";
import HsNation from "@/base/hs-nation/hs-nation.vue";
import DetailsCredentialsItem from "@/pages/personal/passengers/passenger-details/details-credentials-item.vue";
import HsButton from "@/base/hs-button/hs-button.vue";
import {getMarkClassName} from "@/pages/personal/passengers/passenger-details/details";
import HsVanSwitch from "@/base/hs-switch/hs-van-switch.vue";
import HsSwitch from "@/base/hs-switch/hs-switch.vue";

export default {
  props: {
    currentDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
    details: {
      type: Object,
      default: () => {
        return {}
      }
    },
    XOrder: {
      type: Object,
      default: () => {
        return {}
      }
    },
    powerDetails: {
      type: Object,
      default: () => {
        return {}
      }
    },
    credential: {
      type: Object,
      default: () => {
        return {}
      }
    },
    OrderBusinessType: {
      type: Number,
      default: 0
    },
    ExpirationTime: {
      type: String,
      default: null
    },
    submitChecked: {
      type: Boolean,
      default: false
    },
    isNotShowNickName: {
      type: Boolean,
      default: false
    },
    credentialList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  computed: {
    state() {
      return state
    },
    NameCanEdit() {
      return this.PersonalNameCanEdit || this.IsEnableBusinessTravelNameEdit
    },
    IsEnableBusinessEdit() {
      if (
          Number(this.currentDetails.TravelType) === 1 || this.hasPower('我的:常旅客管理:因公编辑')
      ) {
        return true
      } else {
        return this.IsAdd
      }
    },
    PersonalNameCanEdit() {
      return (Number(this.XOrder.TravelType) === 1)
    },
    IsEnableBusinessTravelNameEdit() {
      if (Number(this.currentDetails.TravelType) === 1 || this.hasPower('我的:常旅客管理:因公姓名编辑')) {
        return true
      } else {
        return this.IsAdd
      }
    },
    IsAdd () {
      return !(this.currentDetails.index >= 0)
    },
    isShowNickName() { // 是否展示昵称
      /** 因私 一直都展示 因公度读权限不展示*/
      let isShowNickName = this.getSetting('常用配置:昵称:展示') || Number(this.currentDetails.TravelType) === 1
      // 国际机票需求单 暂时不展示昵称 后端暂不支持
      // if (this.isNotShowNickName) {
      //   isShowNickName = false
      // }
      return isShowNickName
    },
    ChNameSetting() {
      let Required = false
      let IsShowError = !!(this.submitChecked && !this.currentDetails.ChName)
      if (this.OrderBusinessType === 0 && (this.currentDetails.LastName || this.currentDetails.FirstName)) {
        IsShowError = false
      } else { // -1不限 0中文 1英文
        Required = this.OrderBusinessType !== 0 && this.currentDetails.DefaultNameType === 0
      }
      return {
        Show: this.currentDetails.DefaultNameType === 0 || this.OrderBusinessType === 0,
        Name: this.$t('ChineseName'),
        ClassName: getMarkClassName('ChName'),
        Required: Required,
        Type: this.NameCanEdit ? 'input' : 'disabled-input',
        Edit: this.NameCanEdit,
        Placeholder: this.NameCanEdit ? this.$t('PleaseFill') : this.$t('Unmodifiable'),
        // ErrTips: this.submitChecked && !this.currentDetails.ChName ? this.$t('PleaseFill') : '',
        IsShowError: IsShowError
      }
    },
    LastNameSetting() {
      let Required = false
      let IsShowError = false
      let ErrTips = ''
      if (this.submitChecked) {
        if (this.OrderBusinessType === 0) {
          if (!this.currentDetails.ChName && !this.currentDetails.LastName) {
            IsShowError = true
          } else {
            IsShowError = !!(!this.currentDetails.LastName && this.currentDetails.FirstName)
          }
        } else if (this.OrderBusinessType !== 0 && this.currentDetails.DefaultNameType === 1) {
          IsShowError = !this.currentDetails.LastName
        }

        if (this.OrderBusinessType === 0 && this.currentDetails.ChName && !this.currentDetails.FirstName && !this.currentDetails.LastName) {
          IsShowError = false
        }
      }
      if (this.OrderBusinessType !== 0) {
        Required = this.currentDetails.DefaultNameType === 1
      }

      // 未点提交前 只做单独的格式校验
      if (this._checkLastOrFirstName(this.currentDetails.LastName)) {
        ErrTips = this.$t('LastNameFormatIsIncorrect')
        IsShowError = true
      }
      return {
        Show: this.currentDetails.DefaultNameType === 1 || this.OrderBusinessType === 0,
        Name: this.$t('Surname'),
        ClassName: getMarkClassName('LastName'),
        Subtitle: (this.language === 'CN' || this.language === 'TC') ? 'Surname' : '',
        Required: Required,
        Type: this.NameCanEdit ? 'input' : 'disabled-input',
        Edit: this.NameCanEdit,
        Placeholder: this.NameCanEdit ? this.$t('SurnameHint') : this.$t('Unmodifiable'),
        ErrTips: ErrTips,
        IsShowError: IsShowError
      }
    },
    FirstNameSetting() {
      let Required = false
      let IsShowError = false
      let ErrTips = ''
      if (this.submitChecked) {
        if (this.OrderBusinessType === 0) {
          if (!this.currentDetails.ChName && !this.currentDetails.FirstName) {
            IsShowError = true
          } else {
            IsShowError = !!(!this.currentDetails.FirstName && this.currentDetails.LastName)
          }
          if (this.currentDetails.ChName && !this.currentDetails.FirstName && !this.currentDetails.LastName) {
            IsShowError = false
          }
        } else if (this.OrderBusinessType !== 0 && this.currentDetails.DefaultNameType === 1) {
          IsShowError = !this.currentDetails.FirstName
        }
        if (this.OrderBusinessType === 0 && this.currentDetails.ChName && !this.currentDetails.FirstName && !this.currentDetails.LastName) {
          IsShowError = false
        }
      }
      if (this.OrderBusinessType !== 0) {
        Required = this.currentDetails.DefaultNameType === 1
      }

      // 未点提交前 只做单独的格式校验
      if (this._checkLastOrFirstName(this.currentDetails.FirstName)) {
        ErrTips = this.$t('FirstNameFormatIsIncorrect')
        IsShowError = true
      }
      return {
        Show: this.currentDetails.DefaultNameType === 1 || this.OrderBusinessType === 0,
        Name: this.$t('GivenNames'),
        ClassName: getMarkClassName('FirstName'),
        Subtitle: (this.language === 'CN' || this.language === 'TC') ? 'Givenname' : '',
        Required: Required,
        Type: this.NameCanEdit ? 'input' : 'disabled-input',
        Edit: this.NameCanEdit,
        Placeholder: this.NameCanEdit ? this.$t('GivenNamesHint') : this.$t('Unmodifiable'),
        ErrTips: ErrTips,
        IsShowError: IsShowError
      }
    },
    NickNameSetting() {
      return {
        Show: this.isShowNickName,
        Name: this.$t('NickName'),
        Required: false,
        Type: this.IsEnableBusinessEdit ? 'input' : 'disabled-input',
        Edit: this.IsEnableBusinessEdit,
        Placeholder: this.IsEnableBusinessEdit ? this.$getPlaceholder(0, false) : this.$t('Unmodifiable'),
      }
    },
    CredentialNameSetting() {
      let Required = this.powerDetails.requiredCredential
      let IsShowError = false
      let ErrTips = ''
      return {
        Show: this.powerDetails.showCredential,
        Name: this.$t('IDType'),
        Required: Required,
        Type: 'disabled-input',
        Edit: true,
        Placeholder: this.IsEnableBusinessEdit ? this.$getPlaceholder(1, false) : this.$t('Unmodifiable'),
        ShowLogo: true,
        ErrTips: ErrTips,
        IsShowError: IsShowError
      }
    },
    CredentialNoSetting() {
      let Required = this.powerDetails.requiredCredential
      let Show = this.powerDetails.showCredential
      let IsShowError = false
      let ErrTips = ''
      if (Show) {
        let CredentialNo = this.credential.CredentialNo
        if (this.submitChecked && Required) {
          if (!CredentialNo) {
            IsShowError = true
            ErrTips = ''
          }
        }
        if (this.credential.CredentialType === 1) {
          let checkObj = this.idCard(CredentialNo)
          if (CredentialNo && !checkObj.valid) {
            IsShowError = true
            ErrTips = checkObj.msg
          }
        }
      }
      return {
        Show: Show,
        Name: this.$t('IDNumber'),
        ClassName: getMarkClassName('CredentialNo'),
        Required: Required,
        Type: this.IsEnableBusinessEdit ? 'input' : 'disabled-input',
        Edit: this.IsEnableBusinessEdit,
        Placeholder: this.IsEnableBusinessEdit ? this.$getPlaceholder(0, false) : this.$t('Unmodifiable'),
        ErrTips: ErrTips,
        IsEnableDesensitize: this.getSetting("常用配置:用户隐私"),
        IsShowError: IsShowError
      }
    },
    EffectiveDateSetting() {
      let Show = this.powerDetails.showCredential && this.powerDetails.showEffectiveDate
      let Required = this.powerDetails.requiredEffectiveDate
      let IsShowError = false
      let ErrTips = ''
      if (Show && Required && this.submitChecked && this.credential && !this.credential.EffectiveDate) {
        IsShowError = true
        ErrTips = ''
      }
      if (Show && this.credential && this.credential.EffectiveDate) {
        ErrTips = this._checkEffectiveDate()
        IsShowError = !!ErrTips
      }
      return {
        Show: Show,
        Name: this.$t('EffectiveDate'),
        ClassName: getMarkClassName('EffectiveDate'),
        Required: Required,
        Type: 'disabled-input',
        Edit: this.IsEnableBusinessEdit,
        Placeholder: this.IsEnableBusinessEdit ? this.$getPlaceholder(1, false) : this.$t('Unmodifiable'),
        ShowLogo: this.IsEnableBusinessEdit,
        ErrTips: ErrTips,
        IsShowError: IsShowError
      }
    },
    CredentialNationSetting() {
      let Required = this.powerDetails.requiredCredentialNation
      let Show = this.powerDetails.showCredential && this.powerDetails.showCredentialNation;
      let IsShowError = false
      let ErrTips = ''
      let Edit = true
      if (Show && Required && this.submitChecked) {
        if (this.credential && (!this.credential.Nation || !this.credential.Nation.Name)) {
          IsShowError = true
        }
      }
      return {
        Show: Show,
        Name: this.$t('DocumentSignatory'),
        ClassName: getMarkClassName('CredentialNation'),
        Required: Required,
        Type: 'disabled-input',
        Edit: Edit,
        Placeholder: Edit ? this.$getPlaceholder(1, false) : this.$t('Unmodifiable'),
        ShowLogo: Edit,
        ErrTips: ErrTips,
        IsShowError: IsShowError
      }
    },

    // 证件有效期最小值
    datePickerMinDate() {
      return new Date()
    },
    // 证件有效期最大值
    datePickerMaxDate() {
      // 获取当前时间
      let currentDate = new Date();
      // 获取当前年份
      let currentYear = currentDate.getFullYear();
      // 将当前年份加上100
      let futureYear = currentYear + 100;
      // 设置 Date 对象的年份为100年后的年份
      currentDate.setFullYear(futureYear);
      return currentDate;
    }
  },
  mixins: [mixinDes],
  data() {
    return {
      showConvertPinyin: false,
      showCredentialNamePicker: false,
      comCreOptions: {
        title: this.$t('IDType'),
        selected: null,
        showConfirm: false,
        data: [],
        onSelect: () => {}
      },

      showDatePicker: false, // 证件有效期选择器
      currentDatePickerValue: '', // 当前的日期选择器上显示的证件有效期

      currentCredentialListActiveIndex: null,
      selectNationCode: '',
      selectNationType: '',

      baseInfoClass: getMarkClassName('baseInfo')
    }
  },
  methods: {
    getMarkClassName,

    switchNameType() {
      this.currentDetails.DefaultNameType = this.currentDetails.DefaultNameType === 0 ? 1 : 0
    },

    convertPinyin() {
      if (!this.NameCanEdit) {
        return
      }
      if (!this.currentDetails.ChName) {
        this.$toast('未填写中文名，不可转拼音')
        return
      }
      console.log('转拼音')
      this.showConvertPinyin = true
    },

    confirmPinyin() {

    },
    cancelPinyin() {
      this.$refs.refLastName && this.$refs.refLastName.focus()
    },

    // 下单选择证件类型
    _initPicker() {
      if (this.CredentialNameSetting.Edit) {
        this.comCreOptions = {
          title: this.$t('IDType'),
          selected: this.credential.CredentialType || null,
          showConfirm: false,
          data: (this.details.Credentials || []).map(v => {
            return {
              text: v.CredentialName,
              subtext: this.certificatesDes(v.CredentialNo || ''),
              value: v.CredentialType
            }
          }),
          onSelect: (val, index, text) => {
            console.log(99999, this.details)
            this.showCredentialNamePicker = false // 证件号
            this.$emit('update:credential', {
              ...this.details.Credentials[index[0]]
            })
          }
        }
        this.showCredentialNamePicker = true
      }
    },

    // 订单填写乘机人详情页面, 打开证件有效期选择弹框
    _openPassengerDatePicker() {
      this.currentDatePickerValue = (this.credential && this.credential.EffectiveDate && this.credential.EffectiveDate !== '1900-01-01') ?
          this.NewDate(this.credential.EffectiveDate)
          :
          this.NewDate(this.getNewDate(this.beTime(new Date()), 3, 0, 0));
      this.currentCredentialListActiveIndex = null;
      this.showDatePicker = true;
    },

    // 证件有效期选择器回调
    _confirmDatePicker() {
      if (this.currentCredentialListActiveIndex || this.currentCredentialListActiveIndex === 0) {
        let index = this.currentCredentialListActiveIndex;
        if (this.credentialList[index]) {
          this.credentialList[index].EffectiveDate = this.beTime(Date.parse(this.currentDatePickerValue))
          this.$emit('update:credentialList', this.credentialList)
        }
      } else {
        this.credential.EffectiveDate = this.beTime(Date.parse(this.currentDatePickerValue))
        this.$emit('update:credential', this.credential)
      }
      this.showDatePicker = false;
    },

    // 校验证件有效期是否过期
    _checkEffectiveDate() {
      if (this.powerDetails.showEffectiveDate && this.credential.EffectiveDate && this.ExpirationTime && this.credential.EffectiveDate < this.ExpirationTime) {
        return this.$t('TheValidityPeriodHasExpired')
      } else {
        return ''
      }
    },

    /** 打开国籍选择弹框 */
    _openSelectNation() {
      // if (!this.CredentialNationSetting.Edit) {
      //   return
      // }
      console.log('打开国籍选择弹框')
      let v = this.credential.Nation
      this.selectNationCode = v && v.Code
      this.currentCredentialListActiveIndex = null;
      this.$refs.HsNation && this.$refs.HsNation.open()
    },

    // 常旅客管理新增证件类型
    _addCredential() {
      let data = []
      let Credentials = this.details.Credentials || []
      let credentialList = this.credentialList || []
      data = Credentials.filter(v => credentialList.findIndex(m => Number(m.CredentialType) === Number(v.CredentialType)) < 0)
      if (data.length <= 0) {
        this.$toast(this.$t('NoMoreCredential'))
        return
      }
      this.comCreOptions = {
        title: this.$t('IDType'),
        selected: null,
        showConfirm: false,
        data: data.map(v => {
          return {
            text: v.CredentialName,
            subtext: this.certificatesDes(v.CredentialNo || ''),
            value: v.CredentialType
          }
        }),
        onSelect: (val, index, text) => {
          this.showCredentialNamePicker = false // 证件号
          let k = index[0]
          this.credentialList.push({...data[k]})
          this.$emit('update:credentialList', this.credentialList)
        }
      }
      this.showCredentialNamePicker = true
    },

    // 删除证件
    _delCredential(index) {
      this.$alert({
        type: 'new',
        content: this.$t('ConfirmTheRemovalOfTheirDocuments'),
        cancelTxt: this.$t('Cancel'),
        confirmTxt: this.$t('Confirm'),
        confirmFn: () => {
          this.credentialList.splice(index, 1)
          this.$emit('update:credentialList', this.credentialList)
        }
      })
    },

    _setCredentialNation(item) {
      console.log('设置国籍')
      let Nation = {
        ID: item.Id,
        Name: this.getNationName(item),
        Code: item.NationDistCode,
        ThreeCharCode: item.NationCode
      }
      if (this.currentCredentialListActiveIndex || this.currentCredentialListActiveIndex === 0) {
        let index = this.currentCredentialListActiveIndex;
        if (this.credentialList[index]) {
          this.credentialList[index].Nation = {...Nation}
          this.$emit('update:credentialList', this.credentialList)
        }
      } else {
        this.credential.Nation = {...Nation}
        this.$emit('update:credential', this.credential)
      }
    },

    // 打开证件有效期选择弹框
    _openSelectEffectiveDate(v, index) {
      this.currentDatePickerValue = (v && v.EffectiveDate && v.EffectiveDate !== '1900-01-01') ?
          this.NewDate(v.EffectiveDate)
          :
          this.NewDate(this.getNewDate(this.beTime(new Date()), 3, 0, 0));
      this.currentCredentialListActiveIndex = index;
      this.showDatePicker = true;
    },

    /** 打开国籍选择弹框 */
    _openCredentialListSelectNation(v, index) {
      console.log('打开国籍选择弹框')
      let Nation = v && v.Nation
      this.selectNationCode = Nation && Nation.Code
      this.currentCredentialListActiveIndex = index;
      this.$refs.HsNation && this.$refs.HsNation.open()
    },

    /** 证件模块本地校验 */
    localCheck() {
      // 如果三个名称都不展示 toast 提示
      if (this.OrderBusinessType === 0 && !this.currentDetails.ChName && !this.currentDetails.FirstName && !this.currentDetails.LastName) {
        this.$toast(this.$t('PleaseEnterYourChineseNameOrEnglishName'))
        return this.baseInfoClass
      }
      // 中文姓名
      if (this.ChNameSetting.Show && this.ChNameSetting.IsShowError) {
        this.$toast(this.$t('PleaseFill_x', 'function', [this.ChNameSetting.Name]))
        return this.ChNameSetting.ClassName
      }
      // LastName
      if (this.LastNameSetting.Show && this.LastNameSetting.IsShowError) {
        this.$toast(this.LastNameSetting.ErrTips || this.$t('PleaseFill_x', 'function', [this.LastNameSetting.Name]))
        return this.LastNameSetting.ClassName
      }
      // FirstName
      if (this.FirstNameSetting.Show && this.FirstNameSetting.IsShowError) {
        this.$toast(this.FirstNameSetting.ErrTips || this.$t('PleaseFill_x', 'function', [this.FirstNameSetting.Name]))
        return this.FirstNameSetting.ClassName
      }
      // 证件号
      if (this.CredentialNoSetting.Show && this.CredentialNoSetting.IsShowError) {
        this.$toast(this.CredentialNoSetting.ErrTips || this.$t('PleaseFill_x', 'function', [this.CredentialNoSetting.Name]))
        return this.CredentialNoSetting.ClassName
      }
      // 证件有效期
      if (this.EffectiveDateSetting.Show && this.EffectiveDateSetting.IsShowError) {
        this.$toast(this.EffectiveDateSetting.ErrTips || this.$t('PleaseSelect_x', 'function', [this.EffectiveDateSetting.Name]))
        return this.EffectiveDateSetting.ClassName
      }
      // 证件签署国
      if (this.CredentialNationSetting.Show && this.CredentialNationSetting.IsShowError) {
        this.$toast(this.$t('PleaseSelect_x', 'function', [this.CredentialNationSetting.Name]))
        return this.CredentialNationSetting.ClassName
      }

      // 校验平铺的证件列表
      if (this.powerDetails.showCredentialList) {
        let Credentials = this.credentialList
        for(let i = 0; i < Credentials.length; i++) {
          let ref = this.$refs[`detailsCredentialsItem${i}`]
          let ClassName = ref && ref[0] && ref[0].localCheck()
          if (ClassName) {
            return ClassName
          }
        }
      }
    },

    // 校验 英文姓名
    _checkLastOrFirstName(val) {
      let reg = /[^a-zA-Z]/
      val = `${val || ''}`
      let LastName = val ? val.replace(/\s*/g, '') : '';
      return val && reg.test(LastName)
    },
  },
  components: {
    HsSwitch,
    HsVanSwitch,
    HsButton,
    DetailsCredentialsItem,
    HsNation,
    CPicker1,
    HsFormCellDes,
    CConvertPinyin,
    HsTeleport,
    HsTag,
    HsCellSmallTitle,
    HsFormCell,
    HsSectionCard
  }
}
</script>

<template>
  <div>
    <hs-section-card
        :class="baseInfoClass"
        :title="$t('TravelerName')"
        :subtext="OrderBusinessType === 0 ? $t('TravelerNameDesc') : ''"
    >
      <div slot="title" class="card-title" v-if="OrderBusinessType !== 0">
        <div class="left">{{$t('BasicInformation')}}</div>
        <div
            class="right"
            v-if="currentDetails.ChName && Number(currentDetails.DefaultNameType) === 1"
        >
          中文名“{{currentDetails.ChName}}”
        </div>
      </div>
      <div class="details">
        <!--中文姓名-->
        <hs-form-cell
            v-if="ChNameSetting.Show"
            :title="ChNameSetting.Name"
            :class="ChNameSetting.ClassName"
            v-model="currentDetails.ChName"
            :type="ChNameSetting.Type"
            :edit="ChNameSetting.Edit"
            :placeholder="ChNameSetting.Placeholder"
            :errTips="ChNameSetting.ErrTips"
            :required="ChNameSetting.Required"
            :is-show-error="ChNameSetting.IsShowError"
            clearable
        >
          <hs-van-switch
              slot="logo"
              v-if="OrderBusinessType !== 0 && powerDetails.showDefaultNameType"
              @click.native.stop="switchNameType"
              :value="currentDetails.DefaultNameType === 1"
              size="25"
              :active-color="'#f0182a'"
              :inactive-color="'#f0182a'"
          >
            <template slot="node">{{currentDetails.DefaultNameType === 1 ? $t("EN") : $t("CN")}}</template>
          </hs-van-switch>
          <!--<hs-tag
              v-if="OrderBusinessType === 0"
              type="gray40" :class="{gray: !ChNameSetting.Edit}" :title="$t('ConvertToPinyin')"
              class="pinyin" slot="logo" @click.native="convertPinyin" />-->
        </hs-form-cell>
        <!--LastName-->
        <hs-form-cell
            ref="refLastName"
            v-if="LastNameSetting.Show"
            :class="LastNameSetting.ClassName"
            :title="LastNameSetting.Name"
            :subtitle="LastNameSetting.Subtitle"
            v-model="currentDetails.LastName"
            :type="LastNameSetting.Type"
            :edit="LastNameSetting.Edit"
            :placeholder="LastNameSetting.Placeholder"
            :errTips="LastNameSetting.ErrTips"
            :required="LastNameSetting.Required"
            :is-show-error="LastNameSetting.IsShowError"
            clearable
        >
          <hs-van-switch
              slot="logo"
              v-if="OrderBusinessType !== 0 && powerDetails.showDefaultNameType"
              @click.native.stop="switchNameType"
              :value="currentDetails.DefaultNameType === 1"
              size="25"
              :active-color="'#f0182a'"
              :inactive-color="'#f0182a'"
          >
            <template slot="node">{{currentDetails.DefaultNameType === 1 ? $t("EN") : $t("CN")}}</template>
          </hs-van-switch>
        </hs-form-cell>
        <!--FirstName-->
        <hs-form-cell
            ref="refFirstName"
            v-if="FirstNameSetting.Show"
            :class="FirstNameSetting.ClassName"
            :title="FirstNameSetting.Name"
            :subtitle="FirstNameSetting.Subtitle"
            v-model="currentDetails.FirstName"
            :type="FirstNameSetting.Type"
            :edit="FirstNameSetting.Edit"
            :placeholder="FirstNameSetting.Placeholder"
            :errTips="FirstNameSetting.ErrTips"
            :is-show-error="FirstNameSetting.IsShowError"
            :required="FirstNameSetting.Required"
            clearable
        />
        <!--昵称-->
        <hs-form-cell
            v-if="NickNameSetting.Show"
            v-model="currentDetails.NickName"
            :title="NickNameSetting.Name"
            :type="NickNameSetting.Type"
            :placeholder="NickNameSetting.Placeholder"
            :edit="NickNameSetting.Edit"
            clearable
        />

        <template v-if="powerDetails.showCredential">
          <!--证件类型-->
          <hs-form-cell
              v-if="CredentialNameSetting.Show"
              @click.native="_initPicker"
              v-model="credential.CredentialName"
              :title="CredentialNameSetting.Name"
              :type="CredentialNameSetting.Type"
              :placeholder="CredentialNameSetting.Placeholder"
              :edit="CredentialNameSetting.Edit"
              :showLogo="CredentialNameSetting.ShowLogo"
              :required="CredentialNameSetting.Required"
          />
          <!--证件号码-->
          <hs-form-cell-des
              v-if="CredentialNoSetting.Show"
              :class="CredentialNoSetting.ClassName"
              :key="credential.CredentialType"
              v-model="credential.CredentialNo"
              :title="CredentialNoSetting.Name"
              :type="CredentialNoSetting.Type"
              :placeholder="CredentialNoSetting.Placeholder"
              :edit="CredentialNoSetting.Edit"
              telFunName="certificatesDes"
              :errTips="CredentialNoSetting.ErrTips"
              :IsEnableDesensitize="CredentialNoSetting.IsEnableDesensitize"
              :required="CredentialNoSetting.Required"
              :is-show-error="CredentialNoSetting.IsShowError"
              clearable
          />
          <!--有效期-->
          <hs-form-cell
              v-if="EffectiveDateSetting.Show"
              :class="EffectiveDateSetting.ClassName"
              @click="_openPassengerDatePicker"
              v-model="credential.EffectiveDate"
              :title="EffectiveDateSetting.Name"
              :type="EffectiveDateSetting.Type"
              :placeholder="EffectiveDateSetting.Placeholder"
              :edit="EffectiveDateSetting.Edit"
              :showLogo="EffectiveDateSetting.ShowLogo"
              :errTips="EffectiveDateSetting.ErrTips"
              :required="EffectiveDateSetting.Required"
              :is-show-error="EffectiveDateSetting.IsShowError"
          />
          <!--证件签署国-->
          <hs-form-cell
              v-if="CredentialNationSetting.Show"
              :class="CredentialNationSetting.ClassName"
              @click="_openSelectNation"
              :value="credential.Nation ? credential.Nation.Name : ''"
              :title="CredentialNationSetting.Name"
              :type="CredentialNationSetting.Type"
              :placeholder="CredentialNationSetting.Placeholder"
              :edit="CredentialNationSetting.Edit"
              :showLogo="CredentialNationSetting.ShowLogo"
              :errTips="CredentialNationSetting.ErrTips"
              :required="CredentialNationSetting.Required"
              :is-show-error="CredentialNationSetting.IsShowError"
          />
        </template>
      </div>
    </hs-section-card>

    <hs-section-card :title="$t('CertificateInformation')" v-if="powerDetails.showCredentialList">
      <div class="details">
        <details-credentials-item
            v-for="(item, index) in credentialList"
            :key="index" :details="item"
            :ref="`detailsCredentialsItem${index}`"
            :IsEnableBusinessEdit="IsEnableBusinessEdit"
            :ExpirationTime="ExpirationTime || beTime(new Date())"
            :IsEnableDesensitize="getSetting('常用配置:用户隐私')"
            :submitChecked="submitChecked"
            @openSelectEffectiveDate="_openSelectEffectiveDate(item, index)"
            @openSelectCredentialNation="_openCredentialListSelectNation(item, index)"
            @credentialNoChange="(v) => $emit('credentialNoChange', v, index)"
            @delCredential="_delCredential(index)"
        />
        <div class="add" v-if="IsEnableBusinessEdit">
          <hs-button class="btn" font-size="14px" height="44px" @click.native="_addCredential"><span></span>{{$t('NewCertificate')}}</hs-button>
        </div>
      </div>
    </hs-section-card>

    <hs-teleport to="body">
      <c-convert-pinyin
          :show.sync="showConvertPinyin"
          @confirm="confirmPinyin"
          @cancel="cancelPinyin"
      />
    </hs-teleport>
    <hs-teleport to="body">
      <c-picker1
          style="z-index: 9"
          :show.sync="showCredentialNamePicker"
          :showConfirm="comCreOptions.showConfirm"
          :selected="comCreOptions.selected"
          :title="comCreOptions.title"
          :data="comCreOptions.data"
          @selected="comCreOptions.onSelect"
      />

      <!-- 证件有效期 -->
      <van-popup v-model="showDatePicker" position="bottom" round safe-area-inset-bottom>
        <van-datetime-picker
            class="hs-date-picker"
            v-model="currentDatePickerValue"
            type="date"
            :title="$t('EffectiveDate')"
            :confirm-button-text="$t('Confirm')"
            :cancel-button-text="$t('Cancel')"
            :min-date="datePickerMinDate"
            :max-date="datePickerMaxDate"
            @confirm="_confirmDatePicker"
            @cancel="showDatePicker = false"
        />
      </van-popup>

      <!-- 国籍 -->
      <hs-nation
          ref="HsNation"
          @select="_setCredentialNation"
          :NationCode="selectNationCode"
      />
    </hs-teleport>
  </div>
</template>

<style scoped lang="stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.details{
  width: 100%;
  .pinyin{
    @extend .hs-font-body;
    flex-shrink: 0;
    width: 80px;
    height: 28px;
    color: $color_black_600;
    margin-bottom: 0;
    margin-left: 12px;
    &.gray{
      color: $color_black_70;
    }
  }
  >.add{
    padding: 8px 12px;
    margin-bottom: 8px;
    >.btn{
      background-color: $color_black_20;
      border-radius: 6px;
      color: $color_theme_300;
      font-weight: 500;
      min-height: 44px;
      line-height: 16px;
      >span{
        display: inline-flex;
        width: 16px;
        height: 16px;
        margin-right: 2px;
        background-image: url('@/assets/image/base/add/icons_16pt_add.png');
        background-size: 100% 100%;
      }
    }
  }
}
.card-title{
  @extend .flex-between;
  align-items: baseline;
  flex-wrap: wrap;
  width: 100%;
  padding: 16px 16px 8px 16px;
  >.left{
    @extend .hs-font-subtitle-big;
  }
  >.right{
    @extend .hs-font-overline-1;
    color: $color_theme_300;
  }
}
.hs-date-picker{
  :deep(.van-picker__toolbar){
    height: 48px;
  }
  :deep(.van-picker__confirm) {
    color: $color_theme_300;
  }
}
</style>
